import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-logger",
  "use": "dv-logger-usage",
  "viewBox": "0 0 15.24 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.24 20\" id=\"dv-logger\"><title>dv-logger</title><g id=\"dv-logger_Page-1\"><g id=\"dv-logger_solarman-v003\"><path id=\"dv-logger_Combined-Shape\" d=\"M15.71,3.81h1a1,1,0,0,1,1,1V8.57a1,1,0,0,1-1,1V19a1,1,0,0,1-1,1H7.14a1,1,0,0,1-1-1V15.24H3.33a1,1,0,0,1-1-1V9.52a1,1,0,0,1,1-1H6.19V4.76a1,1,0,0,1,1-1h7.62V0h1Z\" transform=\"translate(-2.38)\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-logger.svg
// module id = rK07
// module chunks = 268